// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WithGradientBorder_wrapper__2KAa8","selected":"WithGradientBorder_selected__dqa0f"};